export default "/images/404.svg?c02de223480e68abb9b893eaca040e5a";